if (!customElements.get('tru-product-specifications')) {
  customElements.define('tru-product-specifications', class extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribe || typeof subscribe !== 'function') return;
      const variantIds = this.dataset.variantIds.split(',');
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variant = data?.variant;
        if (!variant || !variantIds.includes(String(variant.id))) return;
        this.querySelectorAll('[data-variant-field]').forEach((cell) => {
          cell.textContent = variant[cell.dataset.variantField] || 'Belirtilmemiş';
        });
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = undefined;
    }
  });
}
